// @flow

import styled from "styled-components";

export const UsersValue = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
